<script setup>
import { getSmartPlatform } from '@weathernews/btos-javascript-modules/src/wniutil/common.js'

const route = useRoute()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const isMobile = ref(false)
const cameraId = route.params.id
const { data: livecamData } = await useFetch('/api/livecam/detail', { query: { id: cameraId, type: 'all' } })
if (!isValidAreaAndPref(route.params.area, route.params.pref) || !livecamData.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid CameraId'
  })
}
useCustomMeta('point', livecamData.value.name)
const breadCrumbList = getBreadCrumb(route.params.area, route.params.pref, `${livecamData.value.name}のライブカメラ`)
const tenkiLink = await getTenkiLink(route.params.pref, livecamData.value.citycode, cameraId)
onMounted(() => {
  isMobile.value = getSmartPlatform() !== ''
})
</script>

<template>
  <NuxtLayout
    name="custom"
    :pref="getPrefectureName(route.params.pref)"
    :pref-roma="route.params.pref"
    :bread-crumb-list="breadCrumbList"
  >
    <div class="frame">
      <LivecamContent :livecam-data="livecamData" />
      <LivecamInfo
        v-if="!isMobile"
        :lat="livecamData.lat"
        :lon="livecamData.lon"
        :direction="livecamData.direction"
        :name="livecamData.name"
        :tenki-link="tenkiLink"
      />
    </div>
    <template #main-bottom>
      <LivecamInfo
        v-if="isMobile"
        :lat="livecamData.lat"
        :lon="livecamData.lon"
        :direction="livecamData.direction"
        :name="livecamData.name"
        :tenki-link="tenkiLink"
      />
      <LivecamAroundList
        :title="livecamData.name"
        :lat="livecamData.lat"
        :lon="livecamData.lon"
      />
      <LivecamLogList />
      <LandmarkList
        :title="livecamData.name"
        :citycode="livecamData.citycode"
      />
      <div
        id="ads-btf1-sp"
        class="ads-btf1-sp"
      />
      <HorizontalStackAd
        v-if="!isWebViewFlag"
        left-ad-id="ads-btf2-left-pc"
        right-ad-id="ads-btf2-right-pc"
      />
      <TopicList />
    </template>
  </NuxtLayout>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
